// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 385 ? "84eeec4d" : chunkId) + "." + {"110":"3889d6a8ffc0e416","385":"b0c74fb727a7205f"}[chunkId] + ".js";
};